import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Conflict = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.988 10.525C25.738 6.887 22.7 4 19 4H11C7.138 4 4 7.138 4 11V14.512C4 16.387 4.725 18.137 6.05 19.462L6.537 19.95C7.487 20.9 8 22.15 8 23.488V25C8 26.65 9.35 28 11 28H21C22.65 28 24 26.65 24 25V22.663C24 21.863 24.313 21.113 24.875 20.538L26.825 18.588C27.575 17.838 28 16.826 28 15.763V14.001C28 12.513 27.187 11.214 25.988 10.526V10.525ZM26 15.762C26 16.3 25.788 16.8 25.413 17.175L23.463 19.125C22.513 20.075 22.001 21.325 22.001 22.663V25C22.001 25.55 21.551 26 21.001 26H11.001C10.451 26 10.001 25.55 10.001 25V23.488C10.001 21.613 9.276 19.863 7.951 18.538L7.464 18.05C6.514 17.1 6.001 15.85 6.001 14.513V11C6.001 8.238 8.239 6 11.001 6H19.001C21.414 6 23.439 7.725 23.901 10H20.001C17.801 10 16.001 11.8 16.001 14H11.001C10.451 14 10.001 13.55 10.001 13C10.001 12.45 9.551 12 9.001 12C8.451 12 8.001 12.45 8.001 13C8.001 14.65 9.351 16 11.001 16H16.001C16.001 18.125 18.189 19.663 18.439 19.825C18.901 20.138 19.514 20.013 19.826 19.55C20.138 19.087 20.014 18.475 19.564 18.163C19.164 17.888 18.001 16.901 18.001 15.988V13.988C18.001 12.888 18.901 11.988 20.001 11.988H24.001C25.101 11.988 26.001 12.888 26.001 13.988V15.763L26 15.762Z" />
	</svg>
);

export default Conflict;
